import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

interface TProps {
  children: string;
  className?: string;
  [key: string]: any;
}

/**
 * Unified translation component - uses LanguageContext
 * Usage: <T>Your text here</T>
 */
export const T: React.FC<TProps> = ({ children, className, ...props }) => {
  const { t } = useLanguage();
  const translatedText = t(children);
  
  return (
    <span className={className} {...props}>
      {translatedText}
    </span>
  );
};

export default T;